import * as React from 'react';
import { connect } from 'react-redux';

import { GroupsList } from './GroupsList';
import { MailingSectionContainer } from '../../../../containers/MailingSectionContainer';
import { IAppState } from '../../../../store';

export const GroupsListContainer = connect((state: IAppState) => ({
  groups: state.categoriesGroups,
  mailingSection: React.createElement(MailingSectionContainer),
}))(GroupsList);
